import axiosInstance from "../scenes/utils/axiosInstance";
import { API_ENDPOINTS } from "../config/api";

export default class PatientService {
  addPatient = async (patientData) => {
    try {
      const response = await axiosInstance.post(API_ENDPOINTS.PATIENTS.ADD, patientData);
      return response.data;
    } catch (error) {
      console.log("Hasta ekleme sırasında bir hata oluştu:", error.response?.data || error.message);
      throw error;
    }
  };

  getAllPatients = async (options = {}) => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.PATIENTS.ALL, options);
      if (options.withMeta) {
        return { data: response.data, headers: response.headers };
      }
      return response.data;
    } catch (error) {
      console.log("Tüm hasta bilgilerni getirirken bir hata oluştu.");
      throw error;
    }
  };

  exportPatientsExcel = async (filters = {}) => {
    const response = await axiosInstance.get(API_ENDPOINTS.PATIENTS.EXPORT_EXCEL, {
      params: filters,
      responseType: "blob",
    });
    return response;
  };
}
